import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Facility, ProjectFacilityInUseApi, PermitProjectFacilityService } from 'src/app/services/permit-project-facility.service';
import { NgForm } from '@angular/forms';
import { ApplicationPackageService, ApplicationPackage } from 'src/app/services/application-package.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PermitProjectFacilityAopService, ProjectFacilityAnnualOperatingPlanApi } from 'src/app/services/permit-project-facility-aop.service';
import { PermitAopService } from 'src/app/services/permit-aop.service';
import { PermitApplicationService } from 'src/app/services/permit-application.service';
import { PermitVarianceService } from 'src/app/services/permit-variance.service';
import { ActivatedRoute } from '@angular/router';
import { PermitSubmitStatusService } from 'src/app/services/permit-submit-status.service';
import { DblistService, ListFacilityType } from 'src/app/services/dblist.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: '[app-status-column]',
  templateUrl: './status-column.component.html',
  styleUrls: ['./status-column.component.scss']
})
export class StatusColumnComponent implements OnInit {

  @Input() type: string;

  @Output() showDraftApplicationEvent = new EventEmitter<any>();
  @Output() showVarianceEvent = new EventEmitter<any>();
  @Output() showApplicationEvent = new EventEmitter<any>();
  @Output() showFacilityEvent = new EventEmitter<any>();
  @Output() showOperationEvent = new EventEmitter<any>();

  applicationPackage: ApplicationPackage;

  // FROM PF COMPONENT

  facilities: Facility[];
  facilitiesOfApp: Facility[];
  pfaops: ProjectFacilityAnnualOperatingPlanApi[];
  selectedProjectFacilityId: number;
  facilityInUseStatus = {};
  modalMessage = '';

  varianceStatus: string = 'empty';
  permitAppStatus: string = 'empty';
  aopStatus: string = 'empty';

  aopId: number;

  editFacility: Facility;
  facilityTypes: ListFacilityType[] = [];
  editFacilityTypeId: number = 0;

  @ViewChild('facilityF', {static: false}) appForm: NgForm;

  // END FROM PF COMPONENT

  unsubscribe: Subject<any> = new Subject();
  
  constructor(
    private route: ActivatedRoute,
    private modalConfig: NgbModalConfig,
    private modalService: NgbModal,
    private facilityService: PermitProjectFacilityService,
    private applicationPackageService: ApplicationPackageService,
    private pfaopService: PermitProjectFacilityAopService,
    private varianceService: PermitVarianceService,
    private permitAppService: PermitApplicationService,
    private permitAopService: PermitAopService,
    private permitSubmitStatusService: PermitSubmitStatusService,
    private dbListService : DblistService,
    private toastr: ToastrService,
  ) { modalConfig.backdrop = 'static'; }

  ngOnInit() {

    this.route.url
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(url => {
      if (url.length > 1) {
        this.aopId = parseInt(url[1].path);
      }
    });

    this.applicationPackageService.currentApplicationPackage
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(applicationPackage => {
      if (applicationPackage) {
        this.applicationPackage = applicationPackage;
        // this.aopData.permitAnnualOperatingPlanId = applicationPackage.permitAnnualOperatingPlanId;
      }
    });

    this.varianceService.currentVariance
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(variance => {
      this.varianceStatus = "empty";
      if (variance) {
        if (variance.description) {
          this.varianceStatus = "complete";
          if (this.permitAppStatus == "complete") {
            this.permitSubmitStatusService.changeApplicationPackageStatus(true)
          } else { this.permitSubmitStatusService.changeApplicationPackageStatus(false) };
        }
      } else {
        this.permitSubmitStatusService.changeApplicationPackageStatus(false);
      }
    });

    this.permitAppService.currentApplication
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(permitApp => {
      this.permitAppStatus = "empty";
      if (permitApp) {
        if (permitApp.projectTypeId) {
          this.permitAppStatus = "complete";
          if (this.varianceStatus == "complete") {
            this.permitSubmitStatusService.changeApplicationPackageStatus(true)
          } else { this.permitSubmitStatusService.changeApplicationPackageStatus(false) };
        }
      }
    });

    this.permitAopService.currentAop
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(permitAop => {
      this.aopStatus = "empty";
      if (permitAop) {
        this.aopId = permitAop.permitAnnualOperatingPlanId;
        console.log("useIrrigation: " + permitAop.facilityUseIrrigation)
        if (permitAop.facilityUseIrrigation != null && permitAop.facilityUseHydro != null && permitAop.facilityUseStorage != null) {
          this.aopStatus = "complete";
          this.permitSubmitStatusService.changePermitAnnualOperatingPlanStatus(true);
        } else {
          this.permitSubmitStatusService.changePermitAnnualOperatingPlanStatus(false);
        }
      } else {
        this.permitSubmitStatusService.changePermitAnnualOperatingPlanStatus(false);
      }
    });

    this.facilityService.currentFacilities
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(facilities => {
      this.facilities = facilities;
    });

    this.facilityService.currentFacilitiesByAopId$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(facilities => {
      if (!!facilities) {
        facilities.forEach((f) => {
          this.facilityInUseStatus[f.projectFacilityId] = f.inUse;
        })
      } else {
        this.facilityInUseStatus = {};
      }
      this.facilitiesOfApp = facilities;
    });

    this.pfaopService.currentProjectFacilityAops
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(pfaops => {
      this.pfaops = pfaops;
    });

    this.dbListService.listFacilityType$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(fts => {
      this.facilityTypes = fts;
    });

    this.editFacilityTypeId = 0;
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  canAddEditProjectFacility() {
    if (!!this.pfaops && this.pfaops.length > 0) {
      var canEdit = false;
      this.pfaops.forEach(pfaop => {
        if (pfaop.canEdit) {
          canEdit = true;
        }
      });
      return canEdit;
    }
    else {
      return true;
    }
  }

  newFacilitySubmit(facilityF: NgForm) {
    facilityF.value.listFacilityTypeId = +facilityF.value.listFacilityTypeId;
    this.facilityService.postFacility(facilityF.value, this.applicationPackage, this.aopId);
    this.modalService.dismissAll();
  }

  setEditFacility(facility: Facility) {
    this.editFacility = facility;
    this.editFacilityTypeId = facility.listFacilityTypeId;
  }

  editFacilityUpdateTypeId(event: any) {
    this.editFacilityTypeId = 0;
    for (var i =0; i< this.facilityTypes.length; i++) {
      if (this.facilityTypes[i].name === event.currentTarget.value) {
        this.editFacilityTypeId = this.facilityTypes[i].listFacilityTypeId;
        return;
      }
    }
  }

  editFacilitySubmit(facilityF: NgForm) {
    var isFacilityDirty = false;
    var editCount = 0;
    var data : Facility = {
      projectFacilityId: this.editFacility.projectFacilityId,
      name: this.editFacility.name,
      description: this.editFacility.description,
      ownerAppropriatorId: this.editFacility.ownerAppropriatorId,
      ownerAppropriatorName: this.editFacility.ownerAppropriatorName,
      permitPointOfDiversionId: this.editFacility.permitPointOfDiversionId,
      permitPointOfDiversionName: this.editFacility.permitPointOfDiversionName,
      diversionEndDate: this.editFacility.diversionEndDate,
      deliveryPointLatitude: this.editFacility.deliveryPointLatitude,
      deliveryPointLongitude: this.editFacility.deliveryPointLongitude,
      disabled: this.editFacility.disabled,
      listFacilityTypeId: this.editFacilityTypeId,
      listFacilityName: '',
      isDeleted: this.editFacility.isDeleted,
      inUse: this.editFacility.inUse,
    };

    if (this.editFacility.name !== facilityF.value.editName)
    {
      isFacilityDirty = true;
      editCount += 1;
      data.name = facilityF.value.editName;
    } 
    if (this.editFacility.description !== facilityF.value.editDescription)
    {
      isFacilityDirty = true;
      editCount += 1;
      data.description = facilityF.value.editDescription;
    } 
    if (this.editFacility.deliveryPointLatitude !== +facilityF.value.editDeliveryPointLatitude)
    {
      isFacilityDirty = true;
      editCount += 1;
      data.deliveryPointLatitude = +facilityF.value.editDeliveryPointLatitude;
    } 
    if (this.editFacility.deliveryPointLongitude !== +facilityF.value.editDeliveryPointLongitude)
    {
      isFacilityDirty = true;
      editCount += 1;
      data.deliveryPointLongitude = +facilityF.value.editDeliveryPointLongitude;
    } 
    if (this.editFacility.listFacilityTypeId !== this.editFacilityTypeId)
    {
      isFacilityDirty = true;
      editCount += 1;
      data.listFacilityTypeId = this.editFacilityTypeId;
    } 
    if (isFacilityDirty) {
      this.facilityService.putFacility(data, this.applicationPackage, this.aopId);
    }
    this.editFacility = null;
    this.editFacilityTypeId = 0;
    this.modalService.dismissAll();
  }

  changethis(facId, $event) {
    this.facilityInUseStatus[facId] = $event.target.checked;
  }

  updateFacilityInUseStatus() {
    var inuseApis = [];
    this.facilitiesOfApp.forEach(f => {
      var inusestatus = {
        applicationPackageId : this.applicationPackage.applicationPackageId,
        permitAnnualOperatingPlanId : this.aopId,
        projectFacilityId : f.projectFacilityId,
        inUse : this.facilityInUseStatus[f.projectFacilityId],
      };
      inuseApis.push(inusestatus);
    });
    this.facilityService.putUpdateFacilityInUse(inuseApis);
    this.modalService.dismissAll();
  }

  open(content, label) {
    let size: any;
    this.modalMessage = '';
    if (label === 'modal-facility-table') {size = 'xl';}
    else if (label === 'modal-update-inuse') {
      this.modalMessage = 'Unchecked facilities will no longer be part of application. Continue?';
      size = 'md';
    }
    else {size = 'md';}
    this.modalService.open(content, {ariaLabelledBy: label, size: size});
  }

  deleteFacility() {
    var r = window.confirm('Delete Facility?\n\n' + this.editFacility.name);
    if (r) { 
      if (this.editFacility.isDeleted) {
        this.toastr.info('The facility: ' + this.editFacility.name + ' is already inactive.');
      } else {
        this.editFacility.isDeleted = true;
        this.facilityService.deleteFacility(this.editFacility, this.applicationPackage, this.aopId);
      }
    }
    this.modalService.dismissAll();
  }

  showDraftApplication() {
    this.showDraftApplicationEvent.emit(true);
  }

  showVariance() {
    this.showVarianceEvent.emit(true);
  }

  showApplication() {
    this.showApplicationEvent.emit(true);
  }

  showOperation() {
    this.showOperationEvent.emit(true);
  }

  showFacility(pfaop) {
    this.showFacilityEvent.emit(true);
    this.pfaopService.changePfaopSelected(pfaop);
  }
}
